import { get } from "lodash";

export default class Setting {
  id?: string;
  apiKey: string;
  bitlyToken: string;
  assetsCdn: string;

  constructor(params?: Setting) {
    this.id = get(params, "id", undefined);
    this.apiKey = get(params, "apiKey", "");
    this.bitlyToken = get(params, "bitlyToken", "");
    this.assetsCdn = get(params, "assetsCdn", "");
  }
}
